export enum PROMOTION_BANNER_EVENT {
	CLOSE_BANNER = 'CLOSE_BANNER',
	OPEN_BANNER_FROM_BELL = 'OPEN_BANNER_FROM_BELL',
	INIT_PROMOTIONAL_EVENT = 'INIT_PROMOTIONAL_EVENT',
}
